export default [
  {
    path: '/relComissaoResumoPorVendedor/',
    name: 'relComissaoResumoPorVendedor',
    title: 'relComissaoResumoPorVendedor',
    component: () => import('../views/RelComissaoResumoPorVendedorView.vue'),
    redirect: { name: 'relComissaoResumoPorVendedor-listar' },
    children: [
      {
        path: 'welcome',
        name: 'relComissaoResumoPorVendedor-listar',
        component: () => import('../views/RelComissaoResumoPorVendedorWelcomeView.vue'),
        meta: {
          title: 'Relatório de comissões - Resumo por vendedor',
        },
      },
    ],
  },
];
